import {
  Theme,
  ThemeOptions,
  createTheme,
  responsiveFontSizes,
} from '@mui/material/styles'

export const controlRoomThemeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#2563eb',
      light: '#3b82f6',
      dark: '#1d4ed8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ffc641',
      200: '#FFC7411F',
      300: '#F6E793',
      light: '#FFC74154',
    },
    common: {
      black: '#121212',
      white: '#ffffff',
    },
    error: {
      main: '#AA1D1D',
    },
    grey: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
      A100: '#f9f9f9',
    },
    success: {
      main: '#71B13B',
      contrastText: '#fff',
    },
    background: {
      default: '#f9fafb',
      paper: '#ffffff',
    },
  },
  typography: {
    allVariants: {
      color: '#121212',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#2563eb',
          fontWeight: 600,
          '&:hover': {
            color: '#1d4ed8',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#374151',
          '&.Mui-focused': {
            color: '#2563eb',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#374151',
            '&.Mui-focused': {
              color: '#2563eb',
            },
            '&.MuiInputLabel-colorSecondary': {
              color: '#374151',
              '&.Mui-focused': {
                color: '#2563eb',
              },
            },
          },
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: '#2563eb',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#2563eb',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 6,
        },
        containedPrimary: {
          backgroundColor: '#2563eb',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#1d4ed8',
          },
        },
      },
    },
  },
}

const createdControlRoomTheme: Theme = createTheme(controlRoomThemeOptions)

export const controlRoomTheme = responsiveFontSizes(createdControlRoomTheme)
